module.exports = __webpack_public_path__ + "img/afarsek_yes.b7e2e52c.png";